import React, { useContext, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

import { FormGrid, LabelFieldFormik } from '../../../components';
import { businessFields } from '../../../store/catalogs/forms/business';

import { ReactComponent as LightNote } from '../../../assets/icons/LightNote.svg';
import classes from './FormProfile.module.scss';

const fields = [
  businessFields.typeOfPerson,
  businessFields.businessName,
  businessFields.name,
  { ...businessFields.identificationNumber, topPosition: 'top-right' },
  businessFields.regime
];

const rols = ['admincoowner', 'owner', 'tenant', 'other'];

const FormProfile = () => {
  const { values, setFieldValue, setTouched } = useFormikContext();
  const [fieldsState, setFieldsState] = useState(fields);

  useEffect(() => {
    setTouched({});
    if (rols.includes(values.rol)) {
      fields[0] = { ...fields[0], disabled: false };
      fields[3] = { ...fields[3], disabledType: false };
      setFieldValue('name', '');
      setFieldValue('typeOfPerson', '');
      setFieldValue('businessName', '');
      setFieldValue('identificationType', '');
    } else {
      fields[0] = { ...fields[0], disabled: true };
      fields[3] = { ...fields[3], disabledType: true };
      setFieldValue('typeOfPerson', values.rol === 'business' ? '1' : '2');
      setFieldValue(values.rol === 'business' ? 'name':'businessName', '');
      setFieldValue('identificationType', values.rol === 'business' ? '31':'');
    }
    // // if (!rols.includes(values.rol)) {
    // //   fields[0] = { ...fields[0], disabled: true };
    // //   setFieldValue('typeOfPerson', values.rol === 'business' ? '1' : '2');
    // // }
    // // if (values.rol === 'business') {
    // //   fields[3] = { ...fields[3], disabledType: true };
    // //   setFieldValue('identificationType', '31');
    // // }
  }, []);

  const setFields = (setFieldValue, key, value, values) => {
    if (rols.includes(values.rol)) {
      if (key === 'typeOfPerson') {
        fields[3] = { ...fields[3], disabledType: value === '1' };
        setFieldValue('name', '');
        setFieldValue('businessName', '');
        setFieldValue('identificationType', value === '1' ? '31' : '');
      }
    }
    setFieldValue(key, value);
  };

  return (
    <div className={classes.content}>
      <LightNote />
      <span className={`bold-24 ${classes.title}`}>Cuéntanos un poco más</span>
      <span className={`medium-16 ${classes.subtitle}`}>Completa la información para finalizar.</span>
      <FormGrid
        fields={fieldsState}
        onChange={(key, value) => setFields(setFieldValue, key, value, values)}
        Render={LabelFieldFormik}
      />
    </div>
  );
};

export default FormProfile;
